<script>
import {
  CdrTabs,
  CdrTabPanel,
} from '@rei/cedar';
import analytics from '../../common/analytics';
import isMobile from '../../utils/isMobile';

export default {
  name: 'GiftcardDeliveryMethodComponent',
  components: {
    CdrTabs,
    CdrTabPanel,
  },
  props: {
    tabsData: {
      type: Array,
      required: true,
    },
    siteId: {
      type: String,
      required: true,
    },
    pageDescription: {
      type: String,
      required: true,
    },
  },
  emits: ['changeDelivery'],
  data() {
    return {
      analytics,
      mobile: false,
    };
  },
  mounted() {
    this.checkDevice();
  },
  methods: {
    onTabChange(tabState, tabId) {
      if (tabState) {
        this.$emit('changeDelivery', tabId);
      }
    },
    checkDevice() {
      if (isMobile()) {
        this.mobile = isMobile();
      }
    },
  },
};
</script>

<template>
  <cdr-tabs
    :modifier="mobile ? 'full-width' : 'centered'"
    height="auto"
    data-ui="giftcard-tab-delivery-container"
    class="giftcard-delivery__container"
  >
    <cdr-tab-panel
      v-for="(tab, idx) in tabsData"
      :id="tab.id"
      :key="idx"
      class="giftcard-delivery__panel-tab"
      :name="tab.deliveryType"
      :aria-labelledby="tab.ariaLabel"
      :data-ui="`gift-card-method-message-${tab.dataUi}`"
      @tabChange="onTabChange"
    >
      {{ tab.deliveryDescription }}
    </cdr-tab-panel>
  </cdr-tabs>
</template>
